import React, {useRef, useState} from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, Drawer, IconButton, Typography} from '@material-ui/core'
import CreateOccurrence from './OccurrenceDrawer/CreateOccurrence'
import EditOccurrence from './OccurrenceDrawer/EditOccurrence'
import BatchUploadHome from './OccurrenceDrawer/BatchUploadHome'
import NotFound from '../../../NotFound'
import ErrorBoundary from '../../../../components/ErrorBoundary'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

//******** Images *************************
import Close from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
    root: {minWidth: '420px', alignItems: 'center'},
    drawerContainer: {
        width: '400px',
        padding: '20px',
    },
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    lookupButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
    },
}))

export default function OccurrenceDrawer(props) {
    const classes = useStyles()
    const {
        title,
        openDialog,
        handleCloseDialog,
        handleToggleStatus,
        currenteventcategory,
        eventoccurrence,
    } = props

    // Dialog parameters
    const isChanged = useRef(false)

    const [open, setOpen] = useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const handleCloseWarning = () => {
        if (isChanged.current) {
            setOpen(true)
        } else {
            isChanged.current = false
            setOpen(false)
            handleCloseDialog()
        }
    }

    const handleCloseDiscard = () => {
        setOpen(false)
        handleCloseDialog()
    }

    // End Dialog parameters
    let component = null
    switch (title) {
        case 'Clone Event Occurrence':
            component = (
                <CreateOccurrence
                    currenteventcategory={currenteventcategory}
                    eventoccurrence={eventoccurrence}
                    handleToggleStatus={handleToggleStatus}
                    detectChange={isChanged}
                />
            )
            break
        case 'Create Event Occurrence':
            component = (
                <CreateOccurrence
                    currenteventcategory={currenteventcategory}
                    eventoccurrence={{}}
                    handleToggleStatus={handleToggleStatus}
                    detectChange={isChanged}
                />
            )
            break
        case 'Edit Event Occurrence':
            component = (
                <EditOccurrence
                    currenteventcategory={currenteventcategory}
                    eventoccurrence={eventoccurrence}
                    handleToggleStatus={handleToggleStatus}
                    detectChange={isChanged}
                />
            )
            break
        case 'Batch Record Swipes':
            component = (
                <BatchUploadHome
                    currenteventcategory={currenteventcategory}
                    eventoccurrence={eventoccurrence}
                    handleClose={handleCloseDialog}
                    detectChange={isChanged}
                />
            )
            break
        default:
            component = <NotFound />
    }
    return (
        <>
            <Drawer
                anchor={'right'}
                open={openDialog}
                onClose={handleCloseWarning}
                ModalProps={{disableEnforceFocus: true}}
                PaperProps={{classes: {root: classes.root}}}
            >
                <Box className={classes.drawerContainer}>
                    <Box className={classes.titleBox}>
                        <Typography
                            variant="h5"
                            style={{alignSelf: 'center', color: '#000000'}}
                        >
                            {title}
                        </Typography>
                        <IconButton onClick={handleCloseWarning}>
                            <Close style={{color: '#000000'}} />
                        </IconButton>
                    </Box>

                    {component}
                </Box>
            </Drawer>

            <ErrorBoundary>
                <Dialog
                    aria-labelledby="Confirm discard changes to occurrence"
                    aria-describedby="Discard Occurrence Changes Modal"
                    open={open}
                    scroll="paper"
                    onClose={() => handleClose()}
                >
                    <DialogTitle id="confirmation-discard-changes">
                        You have made changes
                    </DialogTitle>
                    <DialogContent>Do you want to discard them?</DialogContent>
                    <DialogActions>
                        <Button
                            autoFocus
                            onClick={() => handleClose()}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleCloseDiscard} color="primary">
                            Discard
                        </Button>
                    </DialogActions>
                </Dialog>
            </ErrorBoundary>
        </>
    )
}
